import { fields } from "@monorepo/utils/src/variables/projectsData/externalApi/fields";

export const currentFilters = (): Record<string, unknown> => ({
  [fields.FILTER_LOGIN]: {},
  [fields.FILTER_FUND]: {},
});
